const projectDetail = {
  notFound: "Проект не найден",
  backToLayers: "Назад к хабу",
  layers: "Слои",
  layer: "Слой",
  source: "Источник",
  health: "Здоровье",
  status: "Статус",
  documents: "Документы",
  newDoc: "Новый документ",
  noDocuments: "Документов пока нет",
  storyMap: "vStory",
  openMap: "Открыть карту",
  noStoryCards: "Карточек пока нет",
  more: "ещё",
} as const;
export default projectDetail;
